import { ColorEnum } from '@/constants/color'
import { ShiftCloseoutHistoryRowContentProps } from '@/features/shiftCloseouts/components/CreateShiftCloseoutPrompt/parts/ShiftCloseoutHistory/parts/ShiftCloseoutHistoryRow/types'
import { formatShiftCloseoutHistoryDate } from '@/features/shiftCloseouts/utils/formatShiftCloseoutHistoryDate'
import IconButton from '@/features/ui/buttons/components/IconButton'
import PrinterIcon from '@/features/ui/icons/components/PrinterIcon'
import Typography from '@/features/ui/typography'
import { formatPrice } from '@/utils/priceHelper'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

const CompactShiftCloseoutHistoryRow: FC<ShiftCloseoutHistoryRowContentProps> = ({
    item,
    onReprint,
    printing,
}) => {
    const { t } = useTranslation()
    const { styles } = useStyles(stylesheet)
    const { date, time } = formatShiftCloseoutHistoryDate(item.closedAt)

    return (
        <View style={styles.container}>
            <View style={styles.info}>
                <Typography.Description size="large">
                    {t('shiftCloseouts.history.date')}:{' '}
                    <Typography.Description font="bold" size="large">
                        {date}
                    </Typography.Description>{' '}
                    <Typography.Description font="medium" size="large">
                        {time}
                    </Typography.Description>
                </Typography.Description>
                <Typography.Description size="large">
                    {t('shiftCloseouts.history.shiftCloseout')}:{' '}
                    <Typography.Description font="bold" size="large" style={styles.total}>
                        {formatPrice(item.totalAmount.amount, item.totalAmount.currency)}
                    </Typography.Description>
                </Typography.Description>
                {item.profileName && (
                    <Typography.Description size="large">
                        {t('shiftCloseouts.history.author')}:{' '}
                        <Typography.Description font="bold" size="large">
                            {item.profileName}
                        </Typography.Description>
                    </Typography.Description>
                )}
            </View>
            <IconButton
                accessibilityLabel={t('shiftCloseouts.history.reprint')}
                accessibilityRole="button"
                disabled={printing}
                Icon={PrinterIcon}
                onPress={onReprint}
                testID={`reprint-shift-closeout-${item.uuid}`}
                type="outline"
            />
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        paddingTop: 12,
        paddingRight: 12,
        paddingBottom: 12,
        paddingLeft: 16,
        borderColor: ColorEnum.GRAY_200,
        borderRadius: 12,
        borderWidth: 1,
        backgroundColor: ColorEnum.WHITE,
    },
    info: {
        flex: 1,
        minWidth: 0,
        gap: 8,
    },
    total: {
        color: ColorEnum.Emerald600,
    },
})

export default CompactShiftCloseoutHistoryRow
